<template>

    <div ref="dropdown-holder" class="dropdown d-inline-block float-end">
        <button ref="addStory" type="button" v-dropdown data-bs-auto-close="outside" class="btn "><i class="fa fa-plus"></i> Story</button>

        <div class="dropdown-menu" v-on:click.stop>
            <h4>Add Story</h4>
            <div class="mb-3">
                <label class="control-label">Title</label>
                <input ref="title" type="text" v-model="story.title" class="form-control" data-vv-name="title" data-vv-validate-on="input|blur" data-vv-as="title" v-validate="'required'">
                <help-block field="title"/>
            </div>

            <div class="mb-3">
                <label class="control-label">Epic</label>
                <multiselect
                    class=""
                    v-model="epic"
                    placeholder="Unassigned"
                    track-by="id"
                    label="title"
                    pre-select-first="false"
                    :options="epics"
                    :show-labels="false"
                    @input="epicSelected"
                    :taggable="true"
                    @tag="addEpic"
                    data-vv-validate-on="input|blur"
                    data-vv-as="epic"
                    data-vv-name="epic"
                    v-validate="'required'"
            ></multiselect>
            <help-block field="epic"/>

            </div>

            <div class="mb-3">
                <label class="control-label">Assigned</label>
                <user-select :user="story.user" :userChanged="userSelected" :inline="true"></user-select>
            </div>

            <div class="text-end">
                <button type="button" @click="close()" class="btn btn-rounded btn-light me-1">Cancel</button>
                <button type="button" @click="save()" class="btn btn-rounded btn-primary">Save</button>
            </div>
        </div>
    </div>

</template>

<script>
    import { Dropdown } from 'bootstrap-5'

    import { notify } from 'utils'
    import Multiselect from 'vue-multiselect'
    import { filter, cloneDeep } from 'lodash'
    import Story from './../../../../models/story.js'
    import { mapState, mapActions, mapGetters } from 'vuex'
    import UserSelect from 'components/form/input/_user-select'


    export default {
        $_veeValidate: {
            validator: 'new' // give me my own validator scope.
        },
        props: {
            sprint: Object,
            saveUserStory: Function
        },
        components: {
            Multiselect,
            UserSelect,
            Story
        },

        data: function () {
            return {
                story: new Story(),
                epic: null
            }
        },

        computed: {
            ...mapState('users', ['users']),
            ...mapState('yodizproject/epics', {epics: 'list'})
        },

        mounted () {
            this.$refs['dropdown-holder'].addEventListener('shown.bs.dropdown', () => {
                this.$validator.reset();
                this.$refs.title.focus()
            })
        },

        methods: {
            ...mapActions('yodizproject/stories', {
                addListObject: 'addListObject'
            }),

            ...mapActions('yodizproject/epics', {
                saveEpic: 'addSingle'
            }),

            close () {
                this.$validator.reset();
                this.story = new Story()
                this.epic = null
                Dropdown.getOrCreateInstance(this.$refs.addStory).hide()
            },
            save() {

                if (!this._validate()) {
                    notify.error('Form validation failed, please check your inputs and try again.')
                    return
                }

                this.saveUserStory(this.story)

                this.story = new Story()
                this.epic = null

                this.$validator.reset();

                Dropdown.getOrCreateInstance(this.$refs.addStory).hide()

            },
            userSelected(user) {
                this.story.creator_id = user.id
            },
            epicSelected(epic) {
                this.story.epic_id = epic.id
            },
            addEpic(value) {
                this.saveEpic({title: value}).then((response) => {
                    //Set the epic on the select box and set epic_id to story object
                    this.epic = response.data
                    this.epicSelected(this.epic)
                })
            }
        }
    }
</script>

<style >

</style>
